import bridge from '@/utils/bridge';
import { Toast } from 'vant';

export default {
  install(Vue) {
    Vue.prototype.$bsUtils = {
      // 获取链接参数值
      getUrlParams(name) {
        const search =
          window.location.search.substr(1) ||
          window.location.hash.split('?')[1];
        if (!search) return '';
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        let r = search.match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      // 获取浏览器端类型，android,ios,pc
      getClientType() {
        const u = navigator.userAgent;
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          return 'android';
        } else if (isiOS) {
          return 'ios';
        } else {
          return 'pc';
        }
      },
      isWeixin() {
        const u = navigator.userAgent;
        const isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1;
        return isWeixin;
      },
      // 判断是否苹果手机全面屏，iphoneX以后机型
      isIphoneFullScreen() {
        let isIPhone = navigator.userAgent.indexOf('iPhone') > -1;
        // 判断是iphoneX及以后的iphone手机（即iphone带全面屏的手机）
        return (
          window &&
          isIPhone &&
          window.screen.height >= 812 &&
          window.devicePixelRatio >= 2
        );
      },
      // 校验手机号码
      bsCheckPhone(val) {
        var patrn = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/;
        if (!patrn.test(val) || val === '') {
          return false;
        } else {
          return true;
        }
      },
      // 判断输入框是否有表情
      bsHasEmojiCharacter(substring) {
        for (var i = 0; i < substring.length; i++) {
          const hs = substring.charCodeAt(i);
          if (hs >= 0xd800 && hs <= 0xdbff) {
            if (substring.length > 1) {
              const ls = substring.charCodeAt(i + 1);
              var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
              if (uc >= 0x1d000 && uc <= 0x1f77f) {
                return true;
              }
            }
          } else if (substring.length > 1) {
            const ls = substring.charCodeAt(i + 1);
            if (ls === 0x20e3) {
              return true;
            }
          } else {
            if (hs >= 0x2100 && hs <= 0x27ff) {
              return true;
            } else if (hs >= 0x2b05 && hs <= 0x2b07) {
              return true;
            } else if (hs >= 0x2934 && hs <= 0x2935) {
              return true;
            } else if (hs >= 0x3297 && hs <= 0x3299) {
              return true;
            } else if (
              hs === 0xa9 ||
              hs === 0xae ||
              hs === 0x303d ||
              hs === 0x3030 ||
              hs === 0x2b55 ||
              hs === 0x2b1c ||
              hs === 0x2b1b ||
              hs === 0x2b50
            ) {
              return true;
            }
          }
        }
      },
      // 防抖
      bsDebounce(fn, delay) {
        var delay1 = delay || 200;
        var timer;
        return function() {
          var th = this;
          var args = arguments;
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(function() {
            timer = null;
            fn.apply(th, args);
          }, delay1);
        };
      },
      // 节流
      bsThrottle(fn, interval) {
        var last;
        var timer;
        var interval1 = interval || 200;
        
        return function() {
          var th = this;
          var args = arguments;
          var now = +new Date();
          if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(function() {
              last = now;
              fn.apply(th, args);
            }, interval1);
          } else {
            last = now;
            fn.apply(th, args);
          }
        };
      },
      request(promise) {
        return promise
          .then(data => {
            return [null, data];
          })
          .catch(err => [err]);
      },
      toChinesNum(num) {
        let changeNum = [
          '零',
          '一',
          '二',
          '三',
          '四',
          '五',
          '六',
          '七',
          '八',
          '九',
        ];
        let unit = ['', '十', '百', '千', '万'];
        num = parseInt(num);
        let getWan = temp => {
          let strArr = temp
            .toString()
            .split('')
            .reverse();
          let newNum = '';
          for (var i = 0; i < strArr.length; i++) {
            newNum =
              (i == 0 && strArr[i] == 0
                ? ''
                : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
                ? ''
                : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
              newNum;
          }
          return newNum;
        };
        let overWan = Math.floor(num / 10000);
        let noWan = num % 10000;
        if (noWan.toString().length < 4) {
          noWan = '0' + noWan;
        }
        return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
      },
      toast: Toast,
      nativeApi: bridge,
    };
  },
};
